module.exports = __webpack_public_path__ + "img/smtps.b41c60aa.svg";